import { createFileRoute } from '@tanstack/react-router';
import { PublicFormPage } from '@/features/forms/public-form-page';

export const Route = createFileRoute('/f/$slug')({ component: FormRoute });

function FormRoute() {
  const { slug } = Route.useParams();
  return <PublicFormPage key={slug} slug={slug} />;
}
